import React from 'react';
import { motion } from 'framer-motion';
import { Dog, Trophy, Users, Leaf, BookOpen, HeartPulse, ShoppingBag } from 'lucide-react';
export function AboutSection() {
  const icons = [{
    icon: Dog,
    label: 'Mascotas'
  }, {
    icon: Trophy,
    label: 'Deportes'
  }, {
    icon: Users,
    label: 'Familias'
  }, {
    icon: Leaf,
    label: 'Naturaleza'
  }, {
    icon: BookOpen,
    label: 'Educación'
  }, {
    icon: HeartPulse,
    label: 'Bienestar'
  }, {
    icon: ShoppingBag,
    label: 'Comercio'
  }, {
    icon: null,
    label: 'Causa Animal',
    image: 'https://cdn.magicpatterns.com/uploads/xnHwDanW3XKPdgMR98CACq/Logo_latido_y_huella_ICONO_blanco.png'
  }];
  return <section id="movimiento" className="py-24 bg-white relative overflow-hidden" data-id="element-28" data-mp="1snrbia7dmfqe">
      {/* Subtle paw print background */}
      <div className="absolute inset-0 opacity-60 pointer-events-none" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/n65G7S8JBYf9QcBTeinaQ6/PATRON_HUELLAS_fondo.png')",
      backgroundRepeat: 'repeat',
      backgroundSize: '600px auto'
    }} data-id="element-29" data-mp="1nnd66zx5tjw2"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-30" data-mp="xjazo17o2dkj">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-31" data-mp="itwuz6f1ckbh">
          {/* Left Column - Image Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative w-full aspect-[4/5] rounded-3xl overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200 shadow-2xl" data-id="element-32" data-mp="nu1b2vc17d16">
            {/* Placeholder for client image */}
            <div className="absolute inset-0 flex items-center justify-center text-gray-400 font-medium text-sm border-2 border-dashed border-gray-300 m-4 rounded-2xl" data-id="element-33" data-mp="16lkbqvil2f01">
              [Espacio para fotografía del cliente: Pareja joven con mascota]
            </div>

            {/* Dark logo overlay */}
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-34" data-mp="1xsu015sllccv">
              <img src="https://cdn.magicpatterns.com/uploads/vhUxf58FyiZviRFxf3iozE/Gemini_Generated_Image_xkogx9xkogx9xkog.png" alt="Perro y gato con logo Latido & Huella" className="w-full h-full object-cover" data-id="element-35" data-mp="1ssoem7cx8m38" />
            </div>
          </motion.div>

          {/* Right Column - Content */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="flex flex-col justify-center" data-id="element-36" data-mp="1f1t30nb1fqvy">
            <h2 className="text-4xl md:text-5xl text-brand-navy mb-8 leading-tight" data-id="element-37" data-mp="105bsfyaoagag">
              {['Más', 'que', 'un', 'evento.', 'Un', 'movimiento.'].map((word, i) => <motion.span key={i} initial={{
              opacity: 0,
              y: 30,
              filter: 'blur(10px)'
            }} whileInView={{
              opacity: 1,
              y: 0,
              filter: 'blur(0px)'
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: i * 0.15,
              ease: [0.22, 1, 0.36, 1]
            }} className={`inline-block shimmer-text mr-3 ${i >= 4 ? 'text-brand-cyan' : ''}`} data-id="element-38" data-mp="2uh07s1ktgkvd" data-mpi={i}>
                    {word}
                    {i === 3 && <br data-id="element-39" data-mp="2k1rbw3l0ufr8" />}
                  </motion.span>)}
            </h2>

            <div className="space-y-5 text-gray-600 text-base md:text-lg leading-relaxed mb-10" data-id="element-40" data-mp="2o19wey8xkotj">
              <p data-id="element-41" data-mp="2syrv7vt8hnnt">
                En Colombia, el abandono es una realidad que nos toca el
                corazón.{' '}
                <strong className="text-brand-navy" data-id="element-42" data-mp="2xwteohuknozt">Latido & Huella</strong>{' '}
                nace como respuesta para transformar esa realidad en esperanza.
                En esta edición, caminamos y nos unimos por los valientes del{' '}
                <strong className="text-brand-cyan" data-id="element-43" data-mp="1m53wk26isbjs">CEIBA Rionegro</strong>.
              </p>

              <p className="font-semibold text-brand-navy text-lg md:text-xl" data-id="element-44" data-mp="1h7kgqxu6bqpq">
                Tu participación trasciende la meta:
              </p>

              <div className="space-y-4 pl-1" data-id="element-45" data-mp="1v4h60uun904i">
                <div className="flex items-start gap-3" data-id="element-46" data-mp="1q77hriizqui9">
                  <div className="mt-1.5 w-2.5 h-2.5 rounded-full bg-brand-cyan flex-shrink-0" data-id="element-47" data-mp="1q9tqhlhmbg22"></div>
                  <p data-id="element-48" data-mp="252etvh8lcuwl">
                    <strong className="text-brand-navy" data-id="element-49" data-mp="205wtetkaniq2">
                      Donación con Impacto:
                    </strong>{' '}
                    Una parte de los recursos recaudados se destinará a la
                    donación de insumos físicos para fortalecer la labor de la
                    fundación.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-50" data-mp="2nt4wd4u92fox">
                  <div className="mt-1.5 w-2.5 h-2.5 rounded-full bg-brand-cyan flex-shrink-0" data-id="element-51" data-mp="2ix7f8wb5x5b3"></div>
                  <p data-id="element-52" data-mp="32izimf9nrinv">
                    <strong className="text-brand-navy" data-id="element-53" data-mp="32ihdet50pu3t">
                      Zona de Adopción:
                    </strong>{' '}
                    Encuentra al nuevo integrante de tu familia en nuestro
                    espacio dedicado a la adopción responsable, donde el equipo
                    del CEIBA nos acompañará durante todo el evento.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-54" data-mp="2jpvo6rom91s7">
                  <div className="mt-1.5 w-2.5 h-2.5 rounded-full bg-brand-cyan flex-shrink-0" data-id="element-55" data-mp="2oiosjeg6a83r"></div>
                  <p data-id="element-56" data-mp="29tsjbe2dqp1k">
                    <strong className="text-brand-navy" data-id="element-57" data-mp="29uljtxaqwib9">
                      Compromiso Real:
                    </strong>{' '}
                    Al inscribirte, te sumas a un movimiento que cree en las
                    segundas oportunidades y en el bienestar de quienes más nos
                    necesitan.
                  </p>
                </div>
              </div>

              <p className="font-semibold text-brand-navy text-lg md:text-xl pt-2" data-id="element-58" data-mp="bbqi99n8yygl">
                Este no es solo un evento al que asistes; es un movimiento al
                que perteneces.
              </p>
            </div>

            <blockquote className="border-l-4 border-brand-cyan pl-6 py-2" data-id="element-59" data-mp="1m6xfyfz4uj3">
              <p className="text-3xl md:text-4xl text-brand-cyan font-bold italic" data-id="element-60" data-mp="3sszxv02y0pmk">
                "En cada paso late un corazón dejando una huella"
              </p>
            </blockquote>
          </motion.div>
        </div>

        {/* Hexagonal Icons Row */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mt-16" data-id="element-61" data-mp="kc5367waubjk">
          {/* Mobile: horizontal scroll · Desktop: grid */}
          <div className="flex md:grid md:grid-cols-4 lg:grid-cols-8 gap-5 md:gap-4 overflow-x-auto md:overflow-visible snap-x snap-mandatory px-4 md:px-0 -mx-4 md:mx-0 pb-2 scrollbar-hide" data-id="element-62" data-mp="3109bdhb2afai">
            {icons.map((item, index) => <div key={index} className="flex flex-col items-center group flex-shrink-0 md:flex-shrink snap-center w-24 md:w-auto" data-id="element-63" data-mp="1kld9eip8rbnu" data-mpi={index}>
                {/* Hexagon Shape using CSS clip-path */}
                <div className="w-20 h-20 md:w-24 md:h-24 bg-brand-navy flex items-center justify-center mb-3 md:mb-4 transition-transform duration-300 group-hover:scale-110 group-hover:bg-brand-cyan shadow-lg" style={{
              clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)'
            }} data-id="element-64" data-mp="1uael3wor76w0">
                  {item.image ? <img src={item.image} alt={item.label} className="w-10 h-10 md:w-12 md:h-12 object-contain" data-id="element-65" data-mp="28apd531surir" /> : <item.icon className="w-8 h-8 md:w-10 md:h-10 text-white" strokeWidth={1.5} data-id="element-66" data-mp="2d87qr6qrhux3" />}
                </div>
                <span className="text-sm md:text-base font-semibold text-brand-navy text-center group-hover:text-brand-cyan transition-colors whitespace-nowrap" data-id="element-67" data-mp="dy9bygnv23kr">
                  {item.label}
                </span>
              </div>)}
          </div>
          {/* Mobile hint */}
          <p className="md:hidden text-xs text-gray-400 text-center mt-3 italic" data-id="element-68" data-mp="2gqoet8d4fy9i">
            ← Desliza para ver más →
          </p>
        </motion.div>
      </div>
    </section>;
}